import { Outlet } from "react-router-dom";
import { TopNav } from "./TopNav";

export function Layout() {
  return (
    <div className="app-shell">
      <TopNav />
      <main className="app-main">
        <Outlet />
      </main>
      <footer className="app-footer">
        <span>Bitxian — informational only. Not financial advice.</span>
      </footer>
    </div>
  );
}
